import React, { PureComponent } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { server, config, checkAccess } from "../env";
import Loader from "../components/Loader";
import Header from "../components/Header";

export default class Invoices extends PureComponent {
  state = {
    invoices: [],
    url: "/v1/invoice/read",
    next: null,
    show_more_button: "All are caught up!",
  };

  componentDidMount = () => {
    document.title = "Invoices - Proxies.gg";
    this.readInvoices(this.state.url);
  };

  readInvoices = async (url, load_more = null, search = null) => {
    // Load more
    url = load_more !== null ? server + load_more : server + url;

    this.setState({
      show_more_button: <Loader />,
    });

    await axios
      .get(url, config)
      .then((rsp) => {
        this.setState({
          total_invoices: rsp.data.count,
          invoices:
            load_more !== null
              ? this.state.invoices.concat(rsp.data.results)
              : rsp.data.results,
          next:
            rsp.data.next == null
              ? null
              : rsp.data.next.replace(/^.*\/\/[^/]+/, ""),
          show_more_button:
            rsp.data.next == null ? "All are caught up!" : "Show more",
        });
      })
      .catch((err) => {
        checkAccess(err);
      });
  };

  show_more = (url) => {
    this.readInvoices(null, url);
  };

  render() {
    const { invoices, show_more_button, next } = this.state;

    return (
      <div className="main-content">
        <Header pretitle="dashboard" title="Invoices" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h4>All Invoices</h4>
                </div>
                <div className="table-responsive">
                  <table className="table table-sm table-nowrap card-table">
                    <thead>
                      <tr>
                        <th>
                          <Link to="#" className="text-muted">
                            Invoice ID
                          </Link>
                        </th>
                        <th>
                          <Link to="#" className="text-muted">
                            Plan Name
                          </Link>
                        </th>
                        <th>
                          <Link to="#" className="text-muted">
                            Plan Price
                          </Link>
                        </th>
                        <th>
                          <Link to="#" className="text-muted">
                            Product Type
                          </Link>
                        </th>
                        <th>
                          <Link to="#" className="text-muted">
                            Promo Code
                          </Link>
                        </th>
                        <th colspan="2">
                          <Link to="#" className="text-muted">
                            Payment method
                          </Link>
                        </th>
                        <th>
                          <Link to="#" className="text-muted">
                            Status
                          </Link>
                        </th>
                        <th>
                          <Link to="#" className="text-muted">
                            Date
                          </Link>
                        </th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody className="list">
                      {invoices.map((invoice, index) => (
                        <tr key={index}>
                          <td>{invoice.id}</td>
                          <td>{invoice.plan_name}</td>
                          <td>{invoice.plan_price.toFixed(2)}</td>
                          <td>
                            {invoice.proxy_type === "PR_1"
                              ? "Normal"
                              : invoice.proxy_type === "PR_2"
                              ? "ISP"
                              : invoice.proxy_type === "PR_3"
                              ? "Residential"
                              : invoice.proxy_type === "PR_4"
                              ? "Datacenter"
                              : invoice.proxy_type === "PR_6"
                              ? "Premium Residential"
                              : "IPv6"}
                          </td>
                          <td>{invoice.coupon || "N/A"}</td>
                          <td>{invoice.payment_method}</td>
                          <td></td>
                          <td>
                            {invoice.status ? (
                              <div className="badge bg-success-soft">Paid</div>
                            ) : new Date(invoice.created) >
                              Date.now() - 1000 * 60 * 60 ? (
                              <div className="badge bg-warning-soft">
                                Pending
                              </div>
                            ) : (
                              <div className="badge bg-danger-soft">
                                Expired
                              </div>
                            )}
                          </td>
                          <td>
                            <time datetime={invoice.created}>
                              {new Date(invoice.created).toDateString()}
                            </time>
                          </td>

                          <td>
                            <Link
                              to={"/invoice/" + invoice.id}
                              className="btn btn-sm btn-primary"
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <nav aria-label="Page navigation example">
              <ul className="pagination justify-content-end">
                <li
                  className={next === null ? "page-item disabled" : "page-item"}
                >
                  <Link
                    className="page-link"
                    to="#"
                    onClick={next == null ? null : () => this.show_more(next)}
                    tabIndex="-1"
                  >
                    {show_more_button}
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    );
  }
}
